import React, { Component } from "react";
import $ from "jquery";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { Link } from "react-router-dom";
import ColorPlatte from "./ColorPlatte";
import WidgetLogo from "./WidgetLogo";
import LauncherIcon from "./LauncherIcon";
import TitleLogo from "./TitleLogo";
import ChangeFontTab from "./ChangeFontTab";
import jQuery from "jquery";
import Loader from "react-loader-spinner";
import { ToastContainer, toast } from "react-toastify";
class WidgetSettings extends Component {
  constructor() {
    super(...arguments);
    this.state = {
      currentLogoId: "",
      dataUrl: "",
      result: null,
      themeColor: "",
      font: "",
      currentLauncherLogoId: "",
      launcherDataUrl: "",
      launcherLogoResult: "",
      imagePreviewUrl: "",
      imagePreview: false,
      color: "",
      successResp: false,
      showPreview: true,
    };
  }
  componentDidMount() {
    (function () {
      var currentPath = window.location.href;
      var path = window.origin + "/platform/projectmgmt/look-and-feel";
      var path1 = window.origin + "/platform/projectmgmt/look-and-feel/";
      if (currentPath === path || currentPath === path1) {
        $("#tab1").addClass("active");
      } else if (currentPath.includes("/look-and-feel/change-font")) {
        $("#tab_2").addClass("active");
      } else if (currentPath.includes("/look-and-feel/widget-logo")) {
        $("#tab_3").addClass("active");
      } else if (currentPath.includes("/look-and-feel/launcher-icon")) {
        $("#tab_4").addClass("active");
      } else if (currentPath.includes("/look-and-feel/title-logo")) {
        $("#tab_5").addClass("active");
      } else {
        $("#" + localStorage.getItem("last-used-nlu-tab")).addClass("active");
      }
      $("#tab1,#tab_2,#tab_3,#tab_4,#tab_5").on("click", function () {
        $("#tab1,#tab_2,#tab_3,#tab_4,#tab_5").removeClass("active");
        localStorage.setItem("last-used-property-tab", this);
        $(this).addClass("active");
      });
    })();

    jQuery(function ($) {
      var madSelectHover = 0;
      $(".mad-select").each(function () {
        var $input = $(this).find("input"),
          $ul = $(this).find("> ul"),
          $ulDrop = $ul.clone().addClass("mad-select-drop");

        $(this)
          .append(
            '<i className="material-icons">keyboard_arrow_down</i>',
            $ulDrop
          )
          .on({
            hover: function () {
              madSelectHover ^= 1;
            },
            click: function () {
              $ulDrop.toggleClass("show");
            },
          });

        // PRESELECT
        $ul
          .add($ulDrop)
          .find("li[data-value='" + $input.val() + "']")
          .addClass("selected");

        // MAKE SELECTED
        $ulDrop.on("click", "li", function (evt) {
          evt.stopPropagation();
          $input.val($(this).data("value")); // Update hidden input value
          $ul
            .find("li")
            .eq($(this).index())
            .add(this)
            .addClass("selected")
            .siblings("li")
            .removeClass("selected");
        });

        // UPDATE LIST SCROLL POSITION
        $ul.on("click", function () {
          var liTop = $ulDrop.find("li.selected").position().top;
          $ulDrop.scrollTop(liTop + $ulDrop[0].scrollTop);
        });
      });

      $(document).on("mouseup", function () {
        if (!madSelectHover) $(".mad-select-drop").removeClass("show");
      });
    });
    setTimeout(() => {
      this.getWidgetLogo();
      this.getColor();
      this.getFont();
    }, 300);

    var widgetSettingsController = this;
    document.addEventListener("projectChanged", function (event) {
      widgetSettingsController.projectId = event.projectId;
      widgetSettingsController.getWidgetLogo(event.projectId);
      widgetSettingsController.getColor(event.projectId);
      widgetSettingsController.getFont(event.projectId);
      widgetSettingsController.getLauncherIcon(event.projectId);
    });
    var widgetDataLoaderTimer = setInterval(function () {
      if (true) {
        clearTimeout(widgetDataLoaderTimer);
        widgetSettingsController.getWidgetLogo();
        widgetSettingsController.getColor();
        widgetSettingsController.getFont();
        widgetSettingsController.getLauncherIcon();
      }
    }, 3000);
  }
  NotifyFailToSave(falseRes) {
    toast.dismiss();
    toast(<b style={{ color: "red" }}>{falseRes}</b>, {
      position: "top-center",
      color: "red",
    });
  }
  getFont(projectId) {
    if (!projectId) {
      projectId = this.projectId;
      if (!projectId) {
        projectId = localStorage.getItem("currentProjectId");
      }
    }
    var widgetFontController = this;
    $.ajax({
      url: "/api/agent-property",
      async: false,
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      data: {
        projectId: projectId,
        agentPropertyName: "WIDGET_FONT_FAMILY",
      },
      success: function (res) {
        if (res.success === true) {
          if (res.result != null) {
            var fontFamily = res.result["agentPropertyValue"];
            if (fontFamily != "") {
              widgetFontController.setState({ font: fontFamily });
              if (document.getElementById("fontText") != null) {
                document.getElementById("fontText").style.fontFamily =
                  fontFamily;
              }
            }
          }
        } else {
          widgetFontController.NotifyFailToSave(res.result);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/platform/";
        }
      },
    });
  }

  getColor(projectId) {
    var widgetColorController = this;
    if (!projectId) {
      projectId = this.projectId;
      if (!projectId) {
        projectId = localStorage.getItem("currentProjectId");
      }
    }
    $.ajax({
      url: "/api/agent-property",
      async: false,
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      data: {
        projectId: projectId,
        agentPropertyName: "THEME_COLOR",
      },
      success: function (res) {
        widgetColorController.state.successResp = true;
        widgetColorController.setState(widgetColorController.state);
        if (res.success === true) {
          if (res.result != null) {
            var themeColor = res.result["agentPropertyValue"];
            if (
              themeColor != "" &&
              document.getElementById("heading") != null &&
              document.getElementById("firstScreenbtn") != null
            ) {
              widgetColorController.setState({ color: themeColor });
              document.getElementById("heading").style.background = themeColor;
              document.getElementById("firstScreenbtn").style.background =
                themeColor;
              $("#hexinput").val(themeColor);
            } else if (
              document.getElementById("heading") != null &&
              document.getElementById("firstScreenbtn") != null
            ) {
              widgetColorController.setState({ color: "#FFAA00" });
              document.getElementById("heading").style.background = "#FFAA00";
              document.getElementById("firstScreenbtn").style.background =
                "#FFAA00";
              widgetColorController.setState({ color: "#FFAA00" });
            }
          }
        } else {
          widgetColorController.setState({ color: "#FFAA00" });
          document.getElementById("heading").style.background = "#FFAA00";
          document.getElementById("firstScreenbtn").style.background =
            "#FFAA00";
          widgetColorController.setState({ color: "#FFAA00" });
          widgetColorController.NotifyFailToSave(res.result);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/platform/";
        }
      },
    });
  }
  getWidgetLogo(projectId) {
    var widgetLogoController = this;
    if (!projectId) {
      projectId = this.projectId;
      if (!projectId) {
        projectId = localStorage.getItem("currentProjectId");
      }
    }
    $.ajax({
      url: "/api/widget-logo",
      async: false,
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      data: { projectId: projectId },
      success: function (res) {
        if (res.success === true) {
          if (res.result != null) {
            let id = res.result.id;
            let currentLogo = res.result.dataUrl;
            widgetLogoController.setState({
              currentLogoId: id,
              dataUrl: currentLogo,
              result: res.result,
            });
            $("#image_Replace").attr("src", currentLogo);
          } else {
            widgetLogoController.setState({
              currentLogoId: "",
              dataUrl: "",
              result: null,
            });
            $("#image_Replace").attr("src", "assets/images/bot.ico");
          }
        } else {
          widgetLogoController.NotifyFailToSave(res.result);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/platform/";
        }
      },
    });
  }
  getLauncherIcon(projectId) {
    if (!projectId) {
      projectId = this.projectId;
      if (!projectId) {
        projectId = localStorage.getItem("currentProjectId");
      }
    }
    var widgetLogoController = this;
    $.ajax({
      url: "/api/launcher-icon",
      async: false,
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      data: { projectId: projectId },
      success: function (res) {
        if (res.success === true) {
          if (res.result != null) {
            let id = res.result.id;
            let currentLogo = res.result.dataUrl;
            widgetLogoController.setState({
              currentLogoId: id,
              dataUrl: currentLogo,
              result: res.result,
              imagePreviewUrl: currentLogo,
              imagePreview: true,
            });
          }
        } else {
          widgetLogoController.NotifyFailToSave(res.result);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/platform/";
        }
      },
    });
  }

  handleSkinChange = (showPreview) => {
    console.log("Should Show Preview: ", showPreview);
    this.setState({ showPreview });
  };

  render() {
    return (
      <Router>
        <div>
          <Loader
            type="TailSpin"
            color="#282a65"
            visible={this.state.successResp ? false : true}
            height={300}
            width={50}
            style={{ textAlign: "center" }}
          />
          <link
            rel="shortcut icon"
            type="image/png"
            href="assets/images/bot.ico"
          />
          {/* Font Awesome Icons */}
          <link
            rel="stylesheet"
            href="plugins/font-awesome/css/font-awesome.min.css"
          />
          <link
            rel="stylesheet"
            href="https://fonts.googleapis.com/icon?family=Material+Icons"
          />
          <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
          <link rel="stylesheet" href="assets/css/adminlte.css" />
          <link rel="stylesheet" href="assets/css/custom-style.css" />

          <link rel="stylesheet" href="assets/css/index.css" />
          <link rel="stylesheet" href="assets/css/modal-style.css" />
          <link rel="stylesheet" href="assets/css/flaticon.css" />
          <link rel="stylesheet" href="assets/css/drop-down-alignment.css" />

          <link rel="stylesheet" href="assets/css/mediaQ.css" />
          <link href="assets/css/styles.css" rel="stylesheet" />
          <link href="styles.css" rel="stylesheet" />
          <link href="assets/css/scrollbar.css" rel="stylesheet" />
          <link rel="stylesheet" href="assets/css/configBot.css" />
          <div
            className="wrapper"
            style={{ display: this.state.successResp ? "block" : "none" }}
          >
            <div
              className="content"
              id="configBotcontainer"
              style={{ marginTop: "-20px" }}
            >
              <h6
                className="nav-item"
                style={{
                  color: "#282a65",
                  marginLeft: "8px",
                  marginTop: "20px",
                  marginBottom: "20px",
                }}
              >
                Widget Look &amp; Feel
              </h6>
              <div className="container-fluid">
                <div className="row">
                  <div className="col-lg-5">
                    <div className="card_container">
                      <div className="col-lg-12 p-0">
                        <div className="card-header border-bottom p-0">
                          <ul
                            className="nav nav-pills mr-auto configNav"
                            style={{ padding: "0.3rem 0rem 0" }}
                          >
                            <li className="nav-item">
                              <a className="nav-link active show">
                                <h3 className="card-title configBoxTitle">
                                  Interface Preview
                                </h3>
                              </a>
                            </li>
                          </ul>
                        </div>
                        {this.state.showPreview ? (
                          <div
                            className="card-body configChatBox"
                            id="fontText"
                          >
                            <div
                              id="myCarousel_1"
                              className="carousel slide col-lg-12"
                              data-ride="carousel"
                              data-interval="false"
                              data-wrap="false"
                            >
                              <div
                                className="carousel-inner w-100 mx-auto"
                                style={{
                                  minHeight: "550px",
                                  maxHeight: "550px",
                                }}
                              >
                                <div className="carousel-item col-12 active">
                                  <div
                                    className="card chatBox"
                                    id="chat_window"
                                    style={{}}
                                  >
                                    <div
                                      className="card-header chat_header config_chat_head"
                                      id="heading"
                                      style={{
                                        backgroundColor: "#FFAA00",
                                        height: "200px",
                                      }}
                                    >
                                      <div className="card-tools">
                                        <button
                                          type="button"
                                          className="btn btn-tool close_btn"
                                          disabled
                                        >
                                          <svg
                                            version="1.1"
                                            xmlns="http://www.w3.org/2000/svg"
                                            xmlnsXlink="http://www.w3.org/1999/xlink"
                                            x="0px"
                                            y="0px"
                                            width="24px"
                                            height="20px"
                                            viewBox="0 0 22 22"
                                            enableBackground="new 0 0 24 24"
                                            xmlSpace="preserve"
                                            fill="#ffffff"
                                          >
                                            <g id="Bounding_Boxes">
                                              <g
                                                id="ui_x5F_spec_x5F_header_copy_3"
                                                display="none"
                                              ></g>
                                              <path
                                                fill="none"
                                                d="M0,0h24v24H0V0z"
                                              />
                                            </g>
                                            <g id="Sharp">
                                              <g
                                                id="ui_x5F_spec_x5F_header_copy_4"
                                                display="none"
                                              ></g>
                                              <path d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41z" />
                                            </g>
                                          </svg>
                                        </button>
                                      </div>
                                      <div className="welcome_body">
                                        <h6>Hey Buddy! Welcome</h6>
                                        <div className="robot_box image-container">
                                          <img
                                            id="image_Replace"
                                            src="assets/images/bot.ico"
                                            width="80px"
                                            height="80px"
                                          />
                                        </div>
                                        <h6 className="text-center">Dhee.ai</h6>
                                        <div
                                          className="text-center shortIntro "
                                          style={{ Align: "center" }}
                                        >
                                          Talk to Dhee AI , your virtual
                                          assistant!
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      className="card-body login_body"
                                      style={{ height: "250px" }}
                                    >
                                      <div className="input-field">
                                        <input
                                          id="userName"
                                          type="text"
                                          className="validate"
                                          placeholder="Name"
                                          value="Preferred Language"
                                          disabled="true"
                                        />
                                        {/* <i className="material-icons">keyboard_arrow_down</i> */}
                                      </div>
                                      <div className="input-field">
                                        <input
                                          id="userName"
                                          type="text"
                                          className="validate"
                                          placeholder="Name"
                                          value="Name"
                                          disabled="true"
                                        />
                                      </div>
                                      <div className="input-field">
                                        <input
                                          id="userphoneNo"
                                          type="text"
                                          className="validate"
                                          value="Phone No"
                                          disabled="true"
                                          required
                                        />
                                      </div>
                                    </div>
                                    <div className="card-footer">
                                      <a
                                        className="btn_round"
                                        id="firstScreenbtn"
                                        style={{ backgroundColor: "#FFAA00" }}
                                      >
                                        <svg
                                          version="1.1"
                                          xmlns="http://www.w3.org/2000/svg"
                                          xmlnsXlink="http://www.w3.org/1999/xlink"
                                          x="0px"
                                          y="0px"
                                          width="24px"
                                          height="24px"
                                          viewBox="0 0 24 24"
                                          enableBackground="new 0 0 24 24"
                                          xmlSpace="preserve"
                                          fill="#ffffff"
                                        >
                                          <g id="Bounding_Boxes">
                                            <path
                                              fill="none"
                                              d="M0,0h24v24H0V0z"
                                            />
                                          </g>
                                          <g id="Sharp">
                                            <path d="M12,4l-1.41,1.41L16.17,11H4v2h12.17l-5.58,5.59L12,20l8-8L12,4z" />
                                          </g>
                                        </svg>
                                      </a>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              paddingTop: "5rem",
                            }}
                          >
                            <h2
                              style={{
                                fontSize: "2rem",
                                color: "#333",
                              }}
                            >
                              Will be available soon!
                            </h2>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-7">
                    <div className="card_container">
                      <div
                        className="col-lg-12 p-0"
                        id="style-1"
                        style={{
                          width: "100px",
                          height: "550px",
                          overflowY: "scroll",
                        }}
                      >
                        <div className="container-fluid">
                          {/* Nav tabs */}
                          <div className="tab-class ">
                            <ul
                              className="nav nav-tabs navCluster border-bottom p-0"
                              style={{ margin: "0 0 0.0em" }}
                            >
                              <Link
                                to="/platform/projectmgmt/look-and-feel"
                                style={{ textDecoration: "none" }}
                              >
                                <li className="nav-item nav-link" id="tab1">
                                  Color Palette
                                </li>
                              </Link>
                              <Link
                                to="/platform/projectmgmt/look-and-feel/change-font"
                                style={{ textDecoration: "none" }}
                              >
                                <li className="nav-item nav-link" id="tab_2">
                                  Change Font
                                </li>
                              </Link>

                              <Link
                                to="/platform/projectmgmt/look-and-feel/widget-logo"
                                style={{ textDecoration: "none" }}
                              >
                                <li className="nav-item nav-link" id="tab_3">
                                  Widget Logo
                                </li>
                              </Link>

                              <Link
                                to="/platform/projectmgmt/look-and-feel/launcher-icon"
                                style={{ textDecoration: "none" }}
                              >
                                <li className="nav-item nav-link" id="tab_4">
                                  Launcher Icon
                                </li>
                              </Link>
                              <Link
                                to="/platform/projectmgmt/look-and-feel/title-logo"
                                style={{ textDecoration: "none" }}
                              >
                                <li className="nav-item nav-link" id="tab_5">
                                  Title Logo
                                </li>
                              </Link>
                            </ul>
                          </div>
                        </div>

                        <div className="card-body p-0">
                          <div className="tab-content col-12 p-0">
                            <Switch>
                              <Route
                                path="/platform/projectmgmt/look-and-feel/change-font"
                                component={ChangeFontTab}
                              ></Route>
                              <Route
                                path="/platform/projectmgmt/look-and-feel/widget-logo"
                                component={WidgetLogo}
                                parentCallback={this.callback}
                              ></Route>
                              <Route
                                path="/platform/projectmgmt/look-and-feel/launcher-icon"
                                component={LauncherIcon}
                                parentCallback={this.callback}
                              ></Route>
                              <Route
                                path="/platform/projectmgmt/look-and-feel/title-logo"
                                component={TitleLogo}
                                parentCallback={this.callback}
                              ></Route>
                              <Route
                                path="/platform/projectmgmt/look-and-feel"
                                render={(props) => (
                                  <ColorPlatte
                                    {...props}
                                    handleSkinChange={this.handleSkinChange}
                                  />
                                )}
                              ></Route>
                            </Switch>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Router>
    );
  }
}
export default WidgetSettings;



// WEBPACK FOOTER //
// ./src/projectmgmt/settings/WidgetSettings.js